var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoryPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37305 0.50293C9.70855 0.410069 12.4593 2.9816 12.6631 6.20703L12.6748 6.52148C12.6742 7.10782 12.5789 7.68116 12.4229 8.22266L12.4219 8.22363C12.3091 8.61614 12.1574 8.97473 11.9648 9.33887L11.7627 9.68164L11.7607 9.68555L6.86816 18.085V18.0859C6.74734 18.2938 6.4315 18.2937 6.31055 18.0859V18.085L1.41797 9.68555L1.41602 9.68164L1.20703 9.3291C1.01714 8.96872 0.86856 8.61318 0.755859 8.22266L0.751953 8.21094C0.562219 7.60791 0.483476 6.96084 0.50293 6.28418C0.618078 3.16947 3.20525 0.599385 6.37305 0.50293Z",
    fill: "#FF00E1",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryPin);
export default __webpack_public_path__ + "static/media/StoryPin.8fa7e7b68178d06b0461da18adc42860.svg";
export { ForwardRef as ReactComponent };